import { ParseGetParams } from "common/ParseGetParams";
import { Loader } from "components/Loader";
import React, { useEffect, useState } from "react";
import "reflect-metadata";
import GetConsultant from "services/Consultant";
import GetTranslations from "services/Translations";
import Socket, { Message } from "websocket/Socket";
import './App.css';
import ConsultantCard from "./components/ConsultantCard";
import Consultant from "./models/Consultant";
import GetConsultants from "./services/Listing";

export const wsSocket = new Socket( `wss://${ window.location.host }/ws`, {
    autoConnect: true,
    autoReconnect: true
} )

interface Props {
}

const App: React.FC<Props> = () => {
    const [ ready, setReady ] = useState( false );
    const [ scrollDown, setScrollDown ] = useState<boolean|undefined>( true )
    const [ locale, setLocale ] = useState( "" );
    const [ translations, setTranslations ] = useState<{ [ key: string ]: string }>( {} );

    const data = ParseGetParams( window.location.search )
    const limit = parseInt( data[ "limit" ] ?? 1 )

    const [ consultants, setConsultants ] = useState<Consultant[] | null>( null )

    useEffect( () => {
        if (limit === 1) {
            return;
        }
        if ((consultants?.length ?? 0) === 0) {
            setScrollDown(undefined);
            setTimeout(() => {
                setScrollDown(true);
            }, 2000)
        }
        if (data["layout"] !== "") {
            return;
        }
        for ( let i = 0; i <= (document.body.scrollHeight - window.innerHeight ); i++ ) {
            setTimeout( () => {
                window.scrollTo( {
                    top     : scrollDown ? i : (document.body.scrollHeight - window.innerHeight) - i,
                    behavior: "smooth"
                } )
                if ( i === (document.body.scrollHeight - window.innerHeight ) ) {
                    setTimeout(() => {
                        setScrollDown( !scrollDown )
                    }, 2000)
                }
            }, i * 100 )
        }
    }, [ scrollDown ] );

    const updateConsultant = ( data: any ) => {
        let changed = false;

        setConsultants( consultants => {
            return consultants?.map( consultant => {
                if ( consultant.id === data.consultant ) {
                    consultant.status = data.status;
                    changed = true
                }
                return consultant
            } ) ?? null

        } )
    }
    useEffect( () => {
        if ( locale !== "" ) {
            // @ts-ignore
            GetTranslations( locale ).then( translations => setTranslations( translations ) )
        }
    }, [ locale ] );

    useEffect( () => {
        fetch()

        wsSocket.addHandler( ( msg?: Message ) => {
            if ( msg ) {
                updateConsultant( msg.data )
            }
        } )

        if ( data[ "locale" ] !== undefined ) {
            setLocale( data[ "locale" ] )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    if ( data[ "listing-key" ] === undefined || data[ "listing-key" ] === "" ) {
        // console.error("No data-promoter-key supplied");
        // return <></>;
    }

    const fetch = async () => {
        if ( data[ "listing-key" ] !== undefined ) {
            const consultants = await GetConsultants( data[ "site-id" ], data[ "listing-key" ] );
            setConsultants( consultants );
        } else {
            const consultant = await GetConsultant( parseInt( data[ "consultant-id" ] ), parseInt( data[ "site-id" ] ) );
            setConsultants( [ consultant ] );
            if ( locale === "" ) {
                setLocale( locale => {
                    if ( locale === "" ) {
                        return consultant.profile.profile_translations[ 0 ].locale
                    }
                    return locale
                } )
            }
        }
        setTimeout( () => {

            setReady( true );
        }, 1 )
    }

    const result = consultants?.slice( 0, limit )

    return ( <div className={`App ${data["layout"]}`} style={ limit > 1 ? {} : { background: "#fff" } }>
        { !ready ? <Loader siteId={ data[ "site-id" ] }/> : <>
            { result?.map( consultant => <ConsultantCard translations={ translations } clickUrl={ data[ "click-url" ] ?? data["profile_url"] + consultant.profile.slug }
                                                         consultant={ consultant } hideButtons={ limit > 1 }/> ) }
        </> }
    </div> );
}

export default App;
